import { render, staticRenderFns } from "./ReportsList.vue?vue&type=template&id=644dc294&"
import script from "./ReportsList.vue?vue&type=script&lang=ts&"
export * from "./ReportsList.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports